import { useTradeSalesStore } from "@fero/stores";
import { useQuery } from "@tanstack/react-query";
import type { PurchaseRequestPreviewReq } from "adl-gen/ferovinum/app/api";
import { useAppService } from "../../use-app-service";
import { tradeSalesKeys } from "../query-keys";

/**
 * Returns a summary preview for a trade sale.
 * If the trade sale is an amendment, it returns the amendment summary preview.
 */
export const useGetTradeSaleSummaryPreview = (
  req: PurchaseRequestPreviewReq,
) => {
  const service = useAppService();
  const { purchaseRequestId, options } = useTradeSalesStore();

  const isAmendment = Boolean(options.isEditMode && purchaseRequestId);

  const summaryPreview = useQuery({
    queryKey: tradeSalesKeys.summaryPreview(req),
    queryFn: () => service.thirdPartySalesSummaryPreview(req),
    enabled: !isAmendment,
  });

  const amendmentSummaryPreview = useQuery({
    queryKey: tradeSalesKeys.amendmentSummaryPreview(req, purchaseRequestId),
    queryFn: () =>
      service.amendTradeSaleSummaryPreview({
        purchaseRequestPreviewRequest: req,
        purchaseRequestId: purchaseRequestId ?? "", // Always defined since we checked enabled for isAmendment
      }),
    enabled: isAmendment,
  });

  return isAmendment ? amendmentSummaryPreview : summaryPreview;
};
